document.addEventListener("DOMContentLoaded", function() {
  // confirm password and password_confirmation are the same
  $('.js-validate-same-password-confirmation').click(function(e){
    var paswd =  $('#user_password').val();
    var con_paswd  = $('#user_password_confirmation').val();
    if (!(paswd == con_paswd)) {
      e.preventDefault();
      alert("Password and confirm password not match");
    }
  });

  // allow to submit form by pressing enter
  const passwordField = document.getElementById("user_password");

  if (passwordField) {
    passwordField.addEventListener("keypress", function (event) {
      if (event.key === "Enter") {
        event.preventDefault();
        document.getElementById("new_user").submit();
      }
    });
  }
});

function revealPassword() {
  // Only execute if password fields exist on the page to avoid unnecessary DOM queries
  const passwordFields = document.querySelectorAll('input[type="password"]');
  if (passwordFields.length === 0) {
    return;
  }

  passwordFields.forEach(function(passwordField) {
    // Check if the password field already has a toggle button to prevent duplicates
    // This is crucial for turbo:load where the same element might be re-rendered
    if (!passwordField.parentNode.querySelector('[data-password-toggle]')) {
      // Create a wrapper div to allow for absolute positioning of the button
      const wrapper = document.createElement('div');
      wrapper.classList.add('password-field-wrapper'); // Add a class for styling if needed
      wrapper.style.position = 'relative'; // Crucial for positioning the button
      wrapper.style.flex = '1'; // Apply full width

      // Insert the wrapper before the password field
      passwordField.parentNode.insertBefore(wrapper, passwordField);
      // Move the password field into the wrapper
      wrapper.appendChild(passwordField);

      // Create the toggle button
      const toggleButton = document.createElement('button');
      toggleButton.setAttribute('type', 'button');
      toggleButton.classList.add('btn', 'btn-sm', 'btn-link', 'text-dark', 'position-absolute', 'shadow-none');
      toggleButton.style.cssText = 'top: 50%; right: 16px; transform: translateY(-50%);';
      toggleButton.setAttribute('data-password-toggle', '');
      toggleButton.setAttribute('tabindex', '-1'); // Keep button out of tab flow, user should interact with input first
      toggleButton.innerHTML = '<i class="fas fa-eye"></i>';

      // Append the button to the wrapper
      wrapper.appendChild(toggleButton);

      // Add the click event listener to the button
      toggleButton.addEventListener('click', function() {
        const type = passwordField.getAttribute('type') === 'password' ? 'text' : 'password';
        passwordField.setAttribute('type', type);

        // Toggle the icon (assuming Font Awesome classes)
        const icon = this.querySelector('i');
        if (icon) {
          icon.classList.toggle('fa-eye');
          icon.classList.toggle('fa-eye-slash');
        }
      });
    }
  });
}

// Attach the function to both DOMContentLoaded (for devise layout)
document.addEventListener("DOMContentLoaded", revealPassword);
// and turbolinks:load (for subsequent page loads)
document.addEventListener("turbolinks:load", revealPassword);
